import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import {
  Card,
  CardContent,
} from "@arcadeai/design-system/components/ui/atoms/card";
import { Package, Plus } from "lucide-react";

type EmptyResourceStateProps = {
  resourceType: string;
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: React.ComponentType<{ className?: string }>;
};

export const EmptyResourceState = ({
  resourceType,
  title,
  description,
  actionLabel,
  onAction,
  icon: Icon = Package,
}: EmptyResourceStateProps) => {
  const defaultTitle = `No ${resourceType} found`;
  const defaultDescription = `Get started by creating your first ${resourceType.toLowerCase()}.`;
  const defaultActionLabel = `Add ${resourceType.slice(0, -1)}`; // Remove 's' from plural

  return (
    <Card className="border-2 border-border/60 border-dashed">
      <CardContent className="flex flex-col items-center justify-center px-8 py-16 text-center">
        <div className="mb-6 rounded-full bg-muted/80 p-6">
          <Icon className="h-12 w-12 text-muted-foreground/60" />
        </div>

        <h3 className="mb-2 font-semibold text-foreground text-xl">
          {title || defaultTitle}
        </h3>

        <p className="mb-6 max-w-md text-muted-foreground leading-relaxed">
          {description || defaultDescription}
        </p>

        {!!onAction && (
          <Button className="gap-2" onClick={onAction} size="sm">
            <Plus className="h-4 w-4" />
            {actionLabel || defaultActionLabel}
          </Button>
        )}
      </CardContent>
    </Card>
  );
};
